import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function OnboardingBodyClosed() {
    return (
        <OnboardingBody title='When a lead is closed'>
            <div>
                <p>
                    Define follow-up sales tasks (such as an upsell or renewal), which will
                    automatically be created when leads are won.
                </p>
                <p>Or, create tasks to re-engage lost leads at a later date.</p>
            </div>
        </OnboardingBody>
    );
}
